export default "__VITE_ASSET__17XvJVB9__"